import lodashGet from 'lodash/get';
import { util } from '@/api/util';
import { getContactLabel } from './common';
export const transformCoreContact2EntityContact = (item, fullUnitPathMap, options) => {
    const { iconPrefix = '', enterpriseId, _account, contactUtil } = options;
    const currentCompanyId = contactUtil.getCurrentCompanyId(_account);
    const obj = {};
    obj.displayEmail = item.email;
    obj.contactName = item.nickName;
    obj.accountName = item.email.toLocaleLowerCase();
    obj.accountId = util.getUnique(item.email, '');
    obj.accountOriginId = item.accountId;
    obj.contactPYName = util.toPinyin(item.nickName);
    const pinyinLabelArr = [];
    item.nickName.split('').forEach((_item) => {
        const pinyin = util.toPinyin(_item);
        pinyinLabelArr.push(pinyin.slice(0, 1));
        return pinyin;
    });
    obj.contactPYLabelName = pinyinLabelArr.join('');
    obj.enterpriseId = enterpriseId;
    obj.accountVisible = 0;
    obj.accountStatus = 0;
    obj.accountType = item.type;
    obj.position = (item.rankList || []).reduce((total, current) => {
        const { unitId } = current;
        if (fullUnitPathMap.has(unitId)) {
            total.push(fullUnitPathMap.get(unitId).pathNameList);
        }
        return total;
    }, []);
    obj.enableIM = item.type === 2;
    if (currentCompanyId) {
        obj.enableIM = obj.enableIM && obj.enterpriseId === currentCompanyId;
    }
    obj.avatar = lodashGet(item, 'smallIconUrl.length', 0) > 0 ? iconPrefix + item.smallIconUrl : '';
    obj.avatarPendant = '';
    obj.visibleCode = 0;
    obj.id = obj.accountOriginId;
    obj.contactLabel = getContactLabel(obj.contactPYName);
    obj.type = 'enterprise';
    obj.updateTime = new Date();
    obj._lastUpdateTime = options.lastUpdateTime;
    obj.source = 'core';
    return obj;
};
export const transformCoreContact2EntityContactItem = (item, enterpriseId, lastUpdateTime) => {
    const email = (item.email || '').toLocaleLowerCase();
    const contactItemType = 'EMAIL';
    return {
        contactItemVal: email,
        contactItemRefer: '',
        contactItemType,
        emailType: 1,
        isDefault: 1,
        contactId: item.accountId,
        enterpriseId,
        updateTime: Date.now(),
        id: util.getUnique(item.accountId, contactItemType, email),
        type: 'enterprise',
        source: 'core',
        _lastUpdateTime: lastUpdateTime,
    };
};
export const transformCoreContact2EntityOrgContact = (item, enterpriseId, lastUpdateTime) => {
    if (!item || !Array.isArray(item.rankList) || !item.rankList.length) {
        return [];
    }
    return item.rankList.map(rankItem => ({
        id: util.getUnique(rankItem.unitId, item.accountId),
        orgId: rankItem.unitId,
        contactId: item.accountId,
        yunxinId: '',
        rankNum: rankItem.accountRank,
        enterpriseId,
        source: 'core',
        type: 'enterprise',
        _lastUpdateTime: lastUpdateTime,
    }));
};
export const transformCoreContact2MultipeData = (modeList, fullUnitPathlist, options) => {
    const contactList = [];
    const contactItemList = [];
    const orgContactList = [];
    const { enterpriseId, lastUpdateTime } = options;
    console.time('[contact_transform]transformCoreContact2MultipeData');
    const fullUnitPathMap = new Map(fullUnitPathlist.map(item => [item.id, item]));
    modeList.forEach(_item => {
        if (!_item.email || !_item.email.length) {
            return;
        }
        const item = Object.assign(Object.assign({}, _item), { orgId: enterpriseId });
        contactList.push(transformCoreContact2EntityContact(item, fullUnitPathMap, Object.assign(Object.assign({}, options), { lastUpdateTime })));
        contactItemList.push(transformCoreContact2EntityContactItem(item, enterpriseId, lastUpdateTime));
        orgContactList.splice(Math.max(0, orgContactList.length - 1), 0, ...transformCoreContact2EntityOrgContact(item, enterpriseId, lastUpdateTime));
    });
    console.timeEnd('[contact_transform]transformCoreContact2MultipeData');
    console.log('[contact_transform]transformCoreContact2MultipeData', contactList, contactItemList, orgContactList);
    return {
        contact: contactList,
        contactItem: contactItemList,
        orgContact: orgContactList,
    };
};
export const lookupOrgFullPath = (options) => {
    const { sourceEntityOrgList, partPathMap, relationshipMap } = options;
    const fullPathMap = partPathMap || new Map();
    const nextNeedAddPathList = new Map();
    const addFullPathInfo = (entityOrgItem) => {
        const { id, idPathList, namePathList } = entityOrgItem;
        if (!relationshipMap.has(id)) {
            return;
        }
        relationshipMap.get(id).forEach(childrenId => {
            const chilrenIdPathlist = idPathList;
            const chilrenNamePathList = namePathList;
            if (fullPathMap.has(childrenId)) {
                const { idPathList: subIdPathList = [], namePathList: subNamePathlist = [] } = fullPathMap.get(childrenId);
                chilrenIdPathlist.push(...subIdPathList);
                chilrenNamePathList.push(...subNamePathlist);
            }
            fullPathMap.set(childrenId, {
                idPathList: chilrenIdPathlist,
                namePathList: chilrenNamePathList,
            });
        });
        relationshipMap.delete(id);
    };
    const addPartPathInfo = (entityOrgItem) => {
        const { orgName, id, parent } = entityOrgItem;
        if (!relationshipMap.has(id)) {
            return;
        }
        relationshipMap.get(id).forEach(childrenId => {
            const chilrenIdPathlist = [id];
            const chilrenNamePathList = [orgName];
            if (fullPathMap.has(childrenId)) {
                const { idPathList: subIdPathList = [], namePathList: subNamePathlist = [] } = fullPathMap.get(childrenId);
                chilrenIdPathlist.push(...subIdPathList);
                chilrenNamePathList.push(...subNamePathlist);
            }
            fullPathMap.set(childrenId, {
                idPathList: chilrenIdPathlist,
                namePathList: chilrenNamePathList,
            });
        });
        if (parent !== '-2') {
            nextNeedAddPathList.set(parent, new Set([...(relationshipMap.get(id) || []), ...(nextNeedAddPathList.get(parent) || [])]));
        }
        relationshipMap.delete(id);
    };
    sourceEntityOrgList.forEach(entityOrgItem => {
        const { idPathList } = entityOrgItem;
        if (idPathList && idPathList.length) {
            addFullPathInfo(entityOrgItem);
        }
        else {
            addPartPathInfo(entityOrgItem);
        }
    });
    return {
        fullPathMap,
        needAddParentPathMap: nextNeedAddPathList,
    };
};
export const flattenServerUnit2FullOrgPath = (rawData, options, _companyId) => {
    if (!Array.isArray(rawData) || !rawData.length) {
        return {
            fullPathList: [],
            entityOrgList: [],
            orgTreeMap: new Map(),
        };
    }
    const randomKey = Math.random();
    const mainCompanyId = options.contactUtil.getCurrentCompanyId(options._account);
    const { lastUpdateTime: _lastUpdateTime } = options;
    const companyId = _companyId || mainCompanyId;
    console.time(`[contact_transform]flattenServerUnit2TreadOrgPath.${randomKey}:${rawData.length}`);
    const flattenMap = new Map();
    const rawDataMap = new Map();
    const rootKey = [];
    const groupByParentIdMap = new Map();
    rawData.forEach(item => {
        if (item.type === 99) {
            item.parentUnitId = '-2';
            item.unitId = companyId && companyId !== mainCompanyId ? `${companyId}_-1` : '-1';
        }
        if (!item.parentUnitId || !item.parentUnitId.length || item.parentUnitId === '-1' || item.parentUnitId === `${companyId}_-1`) {
            item.parentUnitId = companyId && companyId !== mainCompanyId ? `${companyId}_-1` : '-1';
            rootKey.push(item.unitId);
        }
        rawDataMap.set(item.unitId, {
            orgName: item.unitName,
            id: item.unitId,
            originId: item.oriUnitId || item.unitId.split('_').pop() || '',
            orgPYName: util.toPinyin(item.unitName),
            parent: item.parentUnitId,
            type: item.type,
            orgRank: item.rank,
            visibleCode: options.visibleCode || 0,
            enterpriseId: companyId,
            source: 'core',
            _lastUpdateTime,
            idPathList: [],
            namePathList: [],
        });
        if (!groupByParentIdMap.has(item.parentUnitId)) {
            groupByParentIdMap.set(item.parentUnitId, []);
        }
        groupByParentIdMap.get(item.parentUnitId).push(item.unitId);
    });
    const traverServerContactByBreadth = (keys, storedMap, groupByParentIdMap, rawDataMap) => {
        let childrenKeys = [];
        keys.forEach(singleKey => {
            const _increasedChildrenKeys = groupByParentIdMap.has(singleKey) ? groupByParentIdMap.get(singleKey) : [];
            childrenKeys = [...childrenKeys, ..._increasedChildrenKeys];
            const rawDataItem = rawDataMap.get(singleKey);
            const { id: unitId, parent: parentUnitId, orgName: unitName } = rawDataItem;
            const parentPathIdList = [unitId];
            const parentPathNameList = [unitName];
            if (storedMap.get(parentUnitId)) {
                const { pathIdList: _parentPathIdList, pathNameList: _parentPathNameList } = storedMap.get(parentUnitId);
                parentPathIdList.splice(0, 0, ..._parentPathIdList);
                parentPathNameList.splice(0, 0, ..._parentPathNameList);
            }
            else if (rawDataMap.has(parentUnitId) && !parentUnitId.endsWith('-1')) {
                const { id: singleParentUnitId, orgName: singleParentUnitName } = rawDataMap.get(parentUnitId);
                parentPathIdList.unshift(singleParentUnitId);
                parentPathNameList.unshift(singleParentUnitName);
            }
            rawDataMap.set(unitId, Object.assign(Object.assign({}, rawDataItem), { idPathList: parentPathIdList, namePathList: parentPathNameList }));
            storedMap.set(unitId, {
                id: unitId,
                parentId: parentUnitId,
                pathIdList: parentPathIdList,
                pathNameList: parentPathNameList,
                enterpriseId: companyId,
            });
        });
        if (Array.isArray(childrenKeys) && childrenKeys.length) {
            return traverServerContactByBreadth(childrenKeys, storedMap, groupByParentIdMap, rawDataMap);
        }
        return storedMap;
    };
    traverServerContactByBreadth(rootKey, flattenMap, groupByParentIdMap, rawDataMap);
    console.timeEnd(`[contact_transform]flattenServerUnit2TreadOrgPath.${randomKey}:${rawData.length}`);
    return {
        fullPathList: [...flattenMap.values()],
        entityOrgList: [...rawDataMap.values()],
        orgTreeMap: groupByParentIdMap,
    };
};
export const compareServerAndLocalOrg = (serverOrgList, localOrgList) => {
    console.time(`[contact_transform]compareServerAndLocalContact${localOrgList.length}`);
    console.timeEnd(`[contact_transform]compareServerAndLocalContact${localOrgList.length}`);
    return serverOrgList;
};
